import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

export default function InstituteVisibilityControl({ institute, C, onChanged }) {
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  if (!institute?.id) return null;
  const active = institute.is_active !== false;
  const toggle = async () => {
    if (saving) return;
    setSaving(true); setError(''); setMessage('');
    try {
      const { data, error: requestError } = await supabase.rpc('set_institute_active', {
        p_institute_id: institute.id, p_is_active: !active,
      });
      if (requestError) throw requestError;
      onChanged?.(data.institute_ids || [institute.id], data.is_active);
      setMessage(data.is_active ? 'Now shown in category listings and leagues.' : 'Hidden from category listings and leagues.');
    } catch (requestError) { setError(requestError.message || 'Could not update visibility. Please try again.'); }
    finally { setSaving(false); }
  };
  return (
    <section style={{ padding: 16, borderRadius: 14, border: `1px solid ${C.border}`, background: C.bgCard, display: 'grid', gap: 10 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div>
          <strong style={{ color: C.text }}>Directory and league visibility</strong>
          <p style={{ margin: '5px 0 0', color: C.textMuted || C.textSecondary, fontSize: 13, lineHeight: 1.5 }}>Active institutes appear in category listings and Regional, National and Global leagues. Visibility applies across this workspace.</p>
        </div>
        <button type="button" role="switch" aria-checked={active} aria-label="Institute active in directory and leagues" disabled={saving} onClick={toggle}
          style={{ minHeight: 44, minWidth: 110, padding: '10px 16px', borderRadius: 12, border: '1px solid #64748B', background: active ? '#0F5132' : '#334155', color: '#FFFFFF', fontWeight: 800, cursor: saving ? 'wait' : 'pointer', opacity: saving ? 0.65 : 1 }}>
          {saving ? 'Saving…' : active ? '✓ Active' : 'Inactive'}
        </button>
      </div>
      {error && <p role="alert" style={{ margin: 0, color: '#B91C1C', fontSize: 13 }}>{error}</p>}
      {message && <p role="status" style={{ margin: 0, color: C.textSecondary, fontSize: 13 }}>{message}</p>}
    </section>
  );
}
